/* eslint-disable react/prop-types */
import React from 'react';
import Event from './event';

const Events = ({ events, eventsHeader }) => (
  <>
    {events ? (
      <div className="events" id="upcoming">
        {eventsHeader ? <h3>{eventsHeader}</h3> : ''}
        {events.map((event, index) => (
          <Event key={index} event={event} />
        ))}
      </div>
    ) : (
      ''
    )}
  </>
);

export default Events;
